// Funnel answers are free text, so a name arrives however the lead typed it. CSS
// text-transform: capitalize is no substitute -- it uppercases the initial but never
// lowercases the tail, so REILLY stays REILLY.

// Mixed case is a deliberate spelling -- McDonald, DeAngelo, de la Cruz -- so only a
// value carrying no case information of its own is reformatted.
const hasDeliberateCase = (value: string): boolean =>
  value !== value.toUpperCase() && value !== value.toLowerCase()

// Splits on space, hyphen and apostrophe so O'BRIEN and MARY-JANE come back correct.
// Both apostrophes: a phone keyboard produces the curly one.
const capitalizeParts = (value: string): string =>
  value.toLowerCase().replace(/(^|[\s'’-])(.)/g, (_match, separator, character) =>
    separator + character.toUpperCase()
  )

const toTitleCase = (value?: string | null): string => {
  const trimmed = value?.trim()
  if (!trimmed) {
    return ''
  }
  return hasDeliberateCase(trimmed) ? trimmed : capitalizeParts(trimmed)
}

export default toTitleCase
